<template>
  <div class="block-filter changeview-filter">
    <ul v-if="columnsView.options.length" class="nav">
      <li v-for="(view, index) in columnsView.options" :key="index" @click.prevent="storeFilter(view)" :class="{ 'active': activeColumnsView === view.value }">
        <span v-html="view.icon" />
      </li>
    </ul>
    <!-- <change-view-filter-list
    radioName="dropdown"
    :attrCode="index"
    :options="columnView"
    :optionSelected="setCurrentOption(index)"
    @changeFilter="storeFilter"
    class="generic-filter" /> -->
    <!-- <div class="simple-filter-dropdown__content__footer">
      <button class="btn btn-black w-100 apply-filter" @click.prevent="applyFilter()">{{$t('apply-filter')}}</button>
    </div> -->
  </div>
</template>

<script>
import ChangeViewFilterList from './ChangeViewFilterList'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      latestChange: {},
      currentOption: null,
      activeFilter: {}
    }
  },
  computed: {
    columnsView () {
      if (this.options && this.options.columnsView) {
        return this.options.columnsView
      } else {
        return []
      }
    },
    activeColumnsView () {
      return this.$store.getters['listing/getColumnView']
    }
  },
  methods: {
    storeFilter ($event) {
      this.activeFilter['columnsView'] = $event.value
      this.applyFilter()
    },
    applyFilter () {
      if (this.activeFilter['columnsView'] !== this.activeColumnsView) {
        // really changed, apply
        this.$store.commit('listing/setListingView', this.activeFilter)
      }
    }
  },
  components: {
    ChangeViewFilterList
  }
}
</script>
<style lang="scss">
.filter-view-productMode{
  display: none;
}
</style>
